/**
 * @desc 保存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OperateForecastRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/operateForecast/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
